import { JWTUserModel } from 'api/dto/JWTUser.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'auth';

export namespace AuthState {
  export type Domain = {
    loggedUserResource: Resource<Readonly<JWTUserModel>>;
  };

  export const INITIAL_DOMAIN: Domain = {
    loggedUserResource: Resource.createPendingResource(),
  };
}
